import {
  REGISTER_REQUEST,
  REGISTER_FAILURE,
  REGISTER_CLEAR,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_CLEAR,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  VERIFY_REQUEST,
  VERIFY_SUCCESS,
  USER_UPDATE
} from "../actions/";

export default (
  state = {
    isRegistering: false,
    isLoggingIn: false,
    isLoggingOut: false,
    isVerifying: false,
    registerError: null,
    loginError: null,
    logoutError: false,
    isAuthenticated: false,
    user: {}
  },
  action
) => {
  switch (action.type) {
    case REGISTER_CLEAR:
      return {
        ...state,
        registerError: null
      };
    case REGISTER_REQUEST:
      return {
        ...state,
        isRegistering: true,
        registerError: null
      };
    case REGISTER_FAILURE:
      return {
        ...state,
        isRegistering: false,
        isAuthenticated: false,
        registerError: action.message
      };
    case LOGIN_CLEAR:
      return {
        ...state,
        loginError: null
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoggingIn: true,
        loginError: null
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isRegistering: false,
        isLoggingIn: false,
        isAuthenticated: true,
        user: action.user
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoggingIn: false,
        isAuthenticated: false,
        loginError: action.message
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        isLoggingOut: true,
        logoutError: false
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggingOut: false,
        isAuthenticated: false,
        user: {}
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        isLoggingOut: false,
        logoutError: true
      };
    case VERIFY_REQUEST:
      return {
        ...state,
        isVerifying: true,
        verifyingError: false
      };
    case VERIFY_SUCCESS:
      return {
        ...state,
        isVerifying: false
      };
    case USER_UPDATE:
      return {
        ...state,
        user: action.user
      };
    default:
      return state;
  }
};
